import { isUndefined } from 'lodash'

export const sortCrossComparison = (a, b, columnId) => {
  const rowA = a.getValue(columnId) || {}
  const rowB = b.getValue(columnId) || {}

  let compareA
  let compareB

  if (['blur', '-'].includes(rowA.value)) compareA = 100
  else if (isUndefined(rowA.value)) compareA = -1
  else if (!rowA.complete_dataset) compareA = 0
  else compareA = rowA.value

  if (['blur', '-'].includes(rowB.value)) compareB = 100
  else if (isUndefined(rowB.value)) compareB = -1
  else if (!rowB.complete_dataset) compareB = 0
  else compareB = rowB.value

  return compareA < compareB ? 1 : compareA > compareB ? -1 : 0
}

const toTimestamp = (value) => {
  const timestamp = Date.parse(value)

  return Number.isNaN(timestamp) ? undefined : timestamp
}

const compareTimestamps = (a, b) => {
  if (a === b) return 0
  if (a === undefined) return -1
  if (b === undefined) return 1

  return a - b
}

export const sortByDate = (rowA, rowB, columnId) =>
  compareTimestamps(
    toTimestamp(rowA.getValue(columnId)),
    toTimestamp(rowB.getValue(columnId))
  )

export const sortByCreatedStatus = (rowA, rowB, columnId) =>
  compareTimestamps(
    toTimestamp(rowA.getValue(columnId)?.createdAt),
    toTimestamp(rowB.getValue(columnId)?.createdAt)
  )

export const sortByTtl = (rowA, rowB, columnId) =>
  compareTimestamps(rowA.getValue(columnId)?.ttl, rowB.getValue(columnId)?.ttl)
